import { request_list } from '@/commons/hpod';
import Vue from 'vue';
const viewTitle = 'báo cáo'
// initial state
const state = {
    loading: false,
    recharge: {},
    bigpackage: {},
    receipt: {},
    salesDashboard: {},
    tmdtSalesDashboard: {},
    storageByBatchCode: {},
};

// getters
const getters = {};

// actions
const actions = {    
    getRecharge({ commit }, param) {
        commit("setLoading", { loading: true });
        request_list('report/recharge', data => {
            commit('setRecharge', data);
            commit("setLoading", { loading: false });
        }, Vue.http, param, this.state.authentication.token);
    },
    getBigpackage({ commit }, param) {
        commit("setLoading", { loading: true });
        request_list('report/bigpackage', data => {
            commit('setBigpackage', data);
            commit("setLoading", { loading: false });
        }, Vue.http, param, this.state.authentication.token);
    },
    getReceipt({ commit }, param) {
        commit("setLoading", { loading: true });
        request_list('report/receipt', data => {
            commit('setReceipt', data);
            commit("setLoading", { loading: false });
        }, Vue.http, param, this.state.authentication.token);
    },
    getSalesDashboard({ commit }, param) {
        commit("setLoading", { loading: true });
        return new Promise((resolve, reject) => {
            request_list('report/sales-dashboard', data => {
                commit('setSalesDashboard', data);
                commit("setLoading", { loading: false });
                resolve(data.data || []);
            }, Vue.http, param, this.state.authentication.token, (error) => {
                commit("setLoading", { loading: false });
                reject(error);
            });
        });
    },
    getTmdtSalesDashboard({ commit }, param) {
        commit("setLoading", { loading: true });
        return new Promise((resolve, reject) => {
            request_list('report/tmdt-sales-dashboard', data => {
                commit('setTmdtSalesDashboard', data);
                commit("setLoading", { loading: false });
                resolve(data.data || []);
            }, Vue.http, param, this.state.authentication.token, (error) => {
                commit("setLoading", { loading: false });
                reject(error);
            });
        });
    },
    getSalesDetailReport({ commit }, param) {
        commit("setLoading", { loading: true });
        return new Promise((resolve, reject) => {
            request_list('report/sales-detail', data => {
                commit("setLoading", { loading: false });
                resolve(data.data || []);
            }, Vue.http, param, this.state.authentication.token, (error) => {
                commit("setLoading", { loading: false });
                reject(error);
            });
        });
    },
    getTmdtSalesDetailReport({ commit }, param) {
        commit("setLoading", { loading: true });
        return new Promise((resolve, reject) => {
            request_list('report/tmdt-sales-detail', data => {
                commit("setLoading", { loading: false });
                resolve(data.data || []);
            }, Vue.http, param, this.state.authentication.token, (error) => {
                commit("setLoading", { loading: false });
                reject(error);
            });
        });
    },
    getStorageByBatchCodeReport({ commit }, param) {
        commit("setLoading", { loading: true });
        return new Promise((resolve, reject) => {
            request_list('report/storage-by-batch-code', data => {
                commit('setStorageByBatchCode', data);
                commit("setLoading", { loading: false });
                resolve(data.data || []);
            }, Vue.http, param, this.state.authentication.token, (error) => {
                commit("setLoading", { loading: false });
                reject(error);
            });
        });
    }
};

// mutations
const mutations = {
    setRecharge(state, data) {
        state.recharge = data;
    },
    setBigpackage(state, data) {
        state.bigpackage = data;
    },
    setReceipt(state, data) {
        state.receipt = data;
    },
    setSalesDashboard(state, data) {
        state.salesDashboard = data;
    },
    setTmdtSalesDashboard(state, data) {
        state.tmdtSalesDashboard = data;
    },
    setStorageByBatchCode(state, data) {
        state.storageByBatchCode = data;
    },
    setLoading(state, { loading }) {
        state.loading = loading;
    }
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};
